////////////////////////////////////////////////////////////////////////////////
//
// All actions
//
////////////////////////////////////////////////////////////////////////////////

export const Action = {
    notify: 'notify',
    auth: {
        check: 'authCheck',
        login: 'login',
        logout: 'logout',
    },
    landlord: {
        loadEntities: 'llEntitiesLoad',
        loadEntitiesSpecific: 'llEntitiesLoadSpecific',
        deleteEntity: 'llEntityDelete',
        newEntity: 'llEntityNew',
        loadAccounts: 'llAccountsLoad',
        newAccount: 'llAccountNew',
        saveAccount: 'llAccountSave',
        deleteAccount: 'llAccountDelete',
        accountToken: 'llAccountToken'
    },
    account: {
        load: 'accountsLoad',
        delete: 'accountDelete',
        add: 'accountAdd',
        save: 'accountSave',
        token: 'accountToken',
        tokenList: 'accountTokenList',
        tokenRevoke: 'accountTokenRevoke'
        
    },
    app: {
        add: 'appAdd',
        load: 'appsLoad',
        delete: 'appDelete',
        save: 'appSave',
        load_all: 'appLoadAll',
        get:'get'
    },
    site: {
        add: 'siteAdd',
        load: 'siteLoad',
        delete: 'siteDelete',
        save: 'siteSave',
        uploadSiteFile: 'uploadSiteFile' ,
        uploadSiteFirmware:'uploadsiteFirmware',
        listSiteFiles: 'listSiteFiles',
        deleteSiteFile: 'deleteSiteFile',
        listSiteFirmware: 'listSiteFirmware',
        deleteSiteFirmware: 'deleteSiteFirmware',
        deleteAllSiteFiles: 'deleteAllSiteFiles',
        deleteAllSiteFirmware: 'deleteAllSiteFirmware',
        uploadSiteIcon: 'uploadSiteIcon',
        listSiteIcons: 'listSiteIcons',
        deleteSiteIcon: 'deleteSiteIcon',
        deleteAllSiteIcons: 'deleteAllSiteIcons'

    },
    kiosk: {
        add: 'kioskAdd',
        load: 'kioskLoad',
        delete: 'kioskDelete',
        save: 'kioskSave'
    },
    dispenser: {
        add: 'dispenserAdd',
        load: 'dispenserLoad',
        delete: 'dispenserDelete',
        save: 'dispenserSave',
       uploadGroupFile: 'uploadGroupFile' ,
       uploadGroupFirmware: 'uploadGroupFirmware',
        listGroupFiles: 'listGroupFiles',
        deleteGroupFile: 'deleteGroupFile',
        listGroupFirmware: 'listGroupFirmware',
        deleteGroupFirmware: 'deleteGroupFirmware',
        deleteAllGroupFiles: 'deleteAllGroupFiles',
        deleteAllGroupFirmware: 'deleteAllGroupFirmware',
         uploadGroupIcon: 'uploadGroupIcon',
        listGroupIcons: 'listGroupIcons',
        deleteGroupIcon: 'deleteGroupIcon',
        deleteAllGroupIcons: 'deleteAllGroupIcons'

    },
    device: {
        add: 'deviceAdd',
        load: 'deviceLoad',
        load_all: 'deviceLoadAll',
        delete: 'deviceDelete',
        save: 'deviceSave',
        allocate: 'deviceAllocate',
        return: 'deviceReturn',
        AllDeviceAction: 'AllDeviceAction',
        sendMqttGeneralCommand: 'sendMqttGeneralCommand',
        sendMqttDFU:'sendMqttDFU',
        MultiDeviceAction: 'MultiDeviceAction',
        sendMultiDeviceDFU: 'sendMultiDeviceDFU',
        startProvisionProcess:'startProvisionProcess',
        getProvisionSSE:'getProvisionSSE',
        move: 'deviceMove',
        cancelProvisionProcess:'cancelProvisionProcess',
        deleteAll: 'deviceDeleteAll',
         sendFget: 'device/sendFget',
    getFgetResult: 'device/getFgetResult',
    


    },
    transcribePair: {
        load:   'transcribePairLoad',
        add:    'transcribePairAdd',
        delete: 'transcribePairDelete',
    },
    entity: {
        loadConfig: 'loadConfig',
        saveConfig: 'saveConfig',
        uploadEntityFile: 'uploadEntityFile', // Add this line
        uploadEntityFirmware:'uploadEntityFirmware',
         listEntityFiles: 'listEntityFiles',
        deleteEntityFile: 'deleteEntityFile',
        listEntityFirmware: 'listEntityFirmware',
        deleteEntityFirmware: 'deleteEntityFirmware',
        deleteAllEntityFiles: 'deleteAllEntityFiles',
        deleteAllEntityFirmware: 'deleteAllEntityFirmware',
        uploadEntityIcon: 'uploadEntityIcon',
    listEntityIcons: 'listEntityIcons',
    deleteEntityIcon: 'deleteEntityIcon',
    deleteAllEntityIcons: 'deleteAllEntityIcons'
    },
    token: {
    list: 'tokenList',
    revoke: 'tokenRevoke'
}

}

